/*
 * @Author: Assistant
 * @Date: 2025-12-20
 * @Description: AI Video Page 多语言配置
 * @FilePath: /weryai-web/locales/modules/aiVideo.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: 'AI 视频生成',
        pageSubtitle: '使用最先进的 AI 模型，将您的创意转化为精彩视频',
        no_video_try_these: '没有视频？试试这些：',
        tools_banner:'示例',
        recommend_text:'推荐素材',
        do_similar_text:'做同款',
        elegant_lady:'优雅女士',
        sweet_girl:'甜美少女',
        gentleman:'魅力绅士',
        stage_star:'舞台之星',
        schemaToolTextToVideo: '文生视频 AI',
        schemaToolImageToVideo: '图生视频 AI',
        schemaToolVideoToVideo: '视频生视频 AI',
        schemaSoftwareName: 'WeryAI AI 视频生成器',
        schemaSoftwareDesc: '一站式 AI 视频创作平台，聚合 Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika 等模型。文生视频、图生视频、视频生视频。',
        sectionTools: 'AI 视频创作工具',
        sectionToolsDesc: '通过文字提示、照片或现有素材创建 AI 视频。选择下方的创作方式。',
        sectionShowcase: 'AI 视频展示',
        sectionShowcaseDesc: '观看社区使用 Veo、Sora 2、Kling 等模型创作的 AI 视频。',
        sectionModels: 'AI 视频模型',
        sectionModelsDesc: '访问 Veo 3.1、Sora 2、Seedance 2.0、Kling、Runway、Pika 等顶级 AI 视频模型。一站式平台。',
        sectionInspiration: '视频灵感',
        sectionInspirationDesc: '浏览热门 AI 视频创作，一键复刻您喜爱的风格。',
        modelsTitle: '模型',
        modelsDesc: 'Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika 等。',
        toolsDesc: '视频超分、口型同步、换脸等。',
        inspirationDesc: '一键做同款，灵感无限。',
    },
    en: {
        // Page title
        pageTitle: 'AI Video Generation',
        pageSubtitle: 'Transform your creativity into stunning videos with the most advanced AI models',
        no_video_try_these: 'No video? Try these:',
        tools_banner:'Sample',
        recommend_text:'Recommend Materials',
        do_similar_text:'Do Similar',
        elegant_lady:'Elegant Lady',
        sweet_girl:'Sweet Girl',
        gentleman:'Gentleman',
        stage_star:'Stage Star',
        // Schema structured data (for CollectionPage + SoftwareApplication)
        schemaToolTextToVideo: 'Text to Video AI',
        schemaToolImageToVideo: 'Image to Video AI',
        schemaToolVideoToVideo: 'Video to Video AI',
        schemaSoftwareName: 'WeryAI AI Video Generator',
        schemaSoftwareDesc: 'All-in-one AI video creation platform aggregating Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika and more. Text to Video, Image to Video, Video to Video.',
        // Section headings (sr-only, for SEO & accessibility)
        sectionTools: 'AI Video Creation Tools',
        sectionToolsDesc: 'Create AI videos from text prompts, photos, or existing footage. Choose your creation method below.',
        sectionShowcase: 'AI Video Showcase',
        sectionShowcaseDesc: 'Watch AI-generated videos created by the community using Veo, Sora 2, Kling and other models.',
        sectionModels: 'AI Video Models',
        sectionModelsDesc: 'Access top AI video models including Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika and more. All in one platform.',
        sectionInspiration: 'Video Inspiration',
        sectionInspirationDesc: 'Browse trending AI video creations and recreate your favorite styles in one click.',
        modelsTitle: 'Models',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika & more.',
        toolsDesc: 'Upscale, lip sync, face swap & more.',
        inspirationDesc: 'One-click remix from community creations.',
    },
    ja: {
        // ページタイトル
        pageTitle: 'AI ビデオ生成',
        pageSubtitle: '最先端のAIモデルで、創造性を素晴らしいビデオに変換',
        no_video_try_these: 'ビデオがない場合は、これらを試してください：',
        tools_banner: 'サンプル',
        recommend_text: 'おすすめ素材',
        do_similar_text: '同じスタイルで作る',
        elegant_lady:'優雅な女性',
        sweet_girl:'甘い少女',
        gentleman:'魅力ある紳士',
        stage_star:'舞台の星',
        schemaToolTextToVideo: 'テキストから動画 AI',
        schemaToolImageToVideo: '画像から動画 AI',
        schemaToolVideoToVideo: '動画から動画 AI',
        schemaSoftwareName: 'WeryAI AI 動画ジェネレーター',
        schemaSoftwareDesc: 'Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika などを集約するオールインワンAI動画作成プラットフォーム。テキストから動画、画像から動画、動画から動画。',
        sectionTools: 'AI 動画作成ツール',
        sectionToolsDesc: 'テキストプロンプト、写真、既存の素材からAI動画を作成。下から作成方法を選択してください。',
        sectionShowcase: 'AI 動画ショーケース',
        sectionShowcaseDesc: 'Veo、Sora 2、Klingなどのモデルでコミュニティが作成したAI動画をご覧ください。',
        sectionModels: 'AI 動画モデル',
        sectionModelsDesc: 'Veo 3.1、Sora 2、Seedance 2.0、Kling、Runway、PikaなどのトップAI動画モデルにアクセス。ワンプラットフォームで。',
        sectionInspiration: '動画インスピレーション',
        sectionInspirationDesc: '話題のAI動画創作を閲覧し、お気に入りのスタイルをワンクリックで再現。',
        modelsTitle: 'モデル',
        modelsDesc: 'Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika など。',
        toolsDesc: '動画アップスケール、リップシンク、顔交換など。',
        inspirationDesc: 'ワンクリックで同じ作品を作成。',
    },
    ko: {
        // 페이지 제목
        pageTitle: 'AI 비디오 생성',
        pageSubtitle: '가장 진보된 AI 모델로 창의성을 멋진 비디오로 변환',
        no_video_try_these: '비디오가 없으신가요? 이것들을 시도해보세요：',
        tools_banner: '샘플',
        recommend_text: '추천 소재',
        do_similar_text: '비슷하게 만들기',
        elegant_lady:'우아한 여성',
        sweet_girl:'달콤한 소녀',
        gentleman:'매력적인 남성',
        stage_star:'스테이지 스타',
        schemaToolTextToVideo: '텍스트 투 비디오 AI',
        schemaToolImageToVideo: '이미지 투 비디오 AI',
        schemaToolVideoToVideo: '비디오 투 비디오 AI',
        schemaSoftwareName: 'WeryAI AI 비디오 생성기',
        schemaSoftwareDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika 등을 통합한 올인원 AI 비디오 제작 플랫폼. 텍스트 투 비디오, 이미지 투 비디오, 비디오 투 비디오.',
        sectionTools: 'AI 영상 제작 도구',
        sectionToolsDesc: '텍스트 프롬프트, 사진 또는 기존 영상으로 AI 영상을 만드세요. 아래에서 제작 방식을 선택하세요.',
        sectionShowcase: 'AI 영상 쇼케이스',
        sectionShowcaseDesc: 'Veo, Sora 2, Kling 등으로 커뮤니티가 만든 AI 영상을 둘러보세요.',
        sectionModels: 'AI 영상 모델',
        sectionModelsDesc: 'Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika 등 최고의 AI 영상 모델에 접속하세요. 한 플랫폼에서 모두 이용 가능합니다.',
        sectionInspiration: '영상 영감',
        sectionInspirationDesc: '인기 AI 영상 작품을 둘러보고 마음에 드는 스타일을 클릭 한 번으로 재현하세요.',
        modelsTitle: '모델',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika 등.',
        toolsDesc: '업스케일, 립싱크, 얼굴 교체 등.',
        inspirationDesc: '원클릭으로 같은 작품 만들기.',
    },
    tw: {
        // 頁面標題
        pageTitle: 'AI 影片生成',
        pageSubtitle: '使用最先進的 AI 模型，將您的創意轉化為精彩影片',
        no_video_try_these: '沒有影片？試試這些：',
        tools_banner: '範例',
        recommend_text: '推薦素材',
        do_similar_text: '做同款',
        elegant_lady:'優雅女士',
        sweet_girl:'甜美少女',
        gentleman:'魅力绅士',
        stage_star:'舞台之星',
        schemaToolTextToVideo: '文生影片 AI',
        schemaToolImageToVideo: '圖生影片 AI',
        schemaToolVideoToVideo: '影片生影片 AI',
        schemaSoftwareName: 'WeryAI AI 影片生成器',
        schemaSoftwareDesc: '一站式 AI 影片創作平台，聚合 Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika 等模型。文生影片、圖生影片、影片生影片。',
        sectionTools: 'AI 影片創作工具',
        sectionToolsDesc: '透過文字提示、照片或現有素材建立 AI 影片。選擇下方的創作方式。',
        sectionShowcase: 'AI 影片展示',
        sectionShowcaseDesc: '觀看社群使用 Veo、Sora 2、Kling 等模型創作的 AI 影片。',
        sectionModels: 'AI 影片模型',
        sectionModelsDesc: '存取 Veo 3.1、Sora 2、Seedance 2.0、Kling、Runway、Pika 等頂級 AI 影片模型。一站式平台。',
        sectionInspiration: '影片靈感',
        sectionInspirationDesc: '瀏覽熱門 AI 影片創作，一鍵復刻您喜愛的風格。',
        modelsTitle: '模型',
        modelsDesc: 'Veo 3.1、Sora 2、Seedance、Kling、Runway、Pika 等。',
        toolsDesc: '影片超分辨率、口型同步、換臉等。',
        inspirationDesc: '一鍵做同款，靈感無限。',
    },
    pl: {
        // Page title
        pageTitle: 'Generowanie wideo AI',
        pageSubtitle:
            'Zamień swoją kreatywność w zachwycające wideo dzięki najnowocześniejszym modelom AI',
        no_video_try_these: 'Nie ma wideo? Spróbuj te:',
        tools_banner: 'Próbka',
        recommend_text: 'Polecane materiały',
        do_similar_text: 'Zrób podobne',
        elegant_lady: 'Elegancka Dama',
        sweet_girl: 'Słodka Dziewczyna',
        gentleman: 'Dżentelmen',
        stage_star: 'Gwiazda Sceny',
        schemaToolTextToVideo: 'Tekst na wideo AI',
        schemaToolImageToVideo: 'Obraz na wideo AI',
        schemaToolVideoToVideo: 'Wideo na wideo AI',
        schemaSoftwareName: 'WeryAI Generator wideo AI',
        schemaSoftwareDesc: 'Kompleksowa platforma do tworzenia wideo AI agregująca Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika i więcej. Tekst na wideo, Obraz na wideo, Wideo na wideo.',
        sectionTools: 'Narzędzia do tworzenia wideo AI',
        sectionToolsDesc: 'Twórz wideo AI z promptów tekstowych, zdjęć lub istniejących materiałów. Wybierz metodę tworzenia poniżej.',
        sectionShowcase: 'Galeria wideo AI',
        sectionShowcaseDesc: 'Obejrzyj wideo AI stworzone przez społeczność za pomocą Veo, Sora 2, Kling i innych modeli.',
        sectionModels: 'Modele wideo AI',
        sectionModelsDesc: 'Uzyskaj dostęp do czołowych modeli wideo AI, w tym Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika i innych. Wszystko na jednej platformie.',
        sectionInspiration: 'Inspiracje wideo',
        sectionInspirationDesc: 'Przeglądaj popularne twory AI i odtwórz ulubione style jednym kliknięciem.',
        modelsTitle: 'Modele',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika i więcej.',
        toolsDesc: 'Poprawa jakości, synchronizacja ust, zamiana twarzy i więcej.',
        inspirationDesc: 'Remix jednym kliknięciem z prac społeczności.',
    },
    es: {
        // Título de la página
        pageTitle: 'Generación de Videos con IA',
        pageSubtitle: 'Transforma tu creatividad en videos impresionantes con los modelos de IA más avanzados',
        no_video_try_these: 'No hay video? Prueba estos:',
        tools_banner: 'Muestra',
        recommend_text: 'Materiales recomendados',
        do_similar_text: 'Hacer similar',
        elegant_lady: 'Dama Elegante',
        sweet_girl: 'Chica Dulce',
        gentleman: 'Caballero',
        stage_star: 'Estrella del Escenario',
        schemaToolTextToVideo: 'Texto a Video IA',
        schemaToolImageToVideo: 'Imagen a Video IA',
        schemaToolVideoToVideo: 'Video a Video IA',
        schemaSoftwareName: 'WeryAI Generador de Videos IA',
        schemaSoftwareDesc: 'Plataforma integral de creación de videos con IA que agrupa Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika y más. Texto a Video, Imagen a Video, Video a Video.',
        sectionTools: 'Herramientas de creación de videos IA',
        sectionToolsDesc: 'Crea videos IA con indicaciones de texto, fotos o material existente. Elige tu método de creación a continuación.',
        sectionShowcase: 'Galería de videos IA',
        sectionShowcaseDesc: 'Mira videos IA generados por la comunidad con Veo, Sora 2, Kling y otros modelos.',
        sectionModels: 'Modelos de video IA',
        sectionModelsDesc: 'Accede a los principales modelos de video IA como Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika y más. Todo en una plataforma.',
        sectionInspiration: 'Inspiración de video',
        sectionInspirationDesc: 'Explora creaciones de video IA trending y recrea tus estilos favoritos con un clic.',
        modelsTitle: 'Modelos',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika y más.',
        toolsDesc: 'Mejora, sincronización labial, cambio de caras y más.',
        inspirationDesc: 'Remix con un clic desde creaciones de la comunidad.',
    },
    fr: {
        // Titre de la page
        pageTitle: 'Génération de Vidéos IA',
        pageSubtitle: 'Transformez votre créativité en vidéos époustouflantes avec les modèles IA les plus avancés',
        no_video_try_these: 'Pas de vidéo ? Essayez ces:',
        tools_banner: 'Exemple',
        recommend_text: 'Matériaux recommandés',
        do_similar_text: 'Faire similaire',
        elegant_lady: 'Dame Élégante',
        sweet_girl: 'Fille Douce',
        gentleman: 'Gentleman',
        stage_star: 'Star de la Scène',
        schemaToolTextToVideo: 'Texte vers Vidéo IA',
        schemaToolImageToVideo: 'Image vers Vidéo IA',
        schemaToolVideoToVideo: 'Vidéo vers Vidéo IA',
        schemaSoftwareName: 'WeryAI Générateur de Vidéos IA',
        schemaSoftwareDesc: 'Plateforme tout-en-un de création vidéo IA regroupant Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika et plus. Texte vers Vidéo, Image vers Vidéo, Vidéo vers Vidéo.',
        sectionTools: 'Outils de création vidéo IA',
        sectionToolsDesc: 'Créez des vidéos IA à partir de prompts texte, photos ou séquences existantes. Choisissez votre méthode de création ci-dessous.',
        sectionShowcase: 'Galerie de vidéos IA',
        sectionShowcaseDesc: 'Regardez les vidéos IA créées par la communauté avec Veo, Sora 2, Kling et d\'autres modèles.',
        sectionModels: 'Modèles vidéo IA',
        sectionModelsDesc: 'Accédez aux meilleurs modèles vidéo IA dont Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika et plus. Tout sur une seule plateforme.',
        sectionInspiration: 'Inspiration vidéo',
        sectionInspirationDesc: 'Parcourez les créations vidéo IA tendance et recréez vos styles préférés en un clic.',
        modelsTitle: 'Modèles',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika et plus.',
        toolsDesc: 'Amélioration, synchronisation labiale, échange de visages et plus.',
        inspirationDesc: 'Remix en un clic depuis les créations de la communauté.',
    },
    de: {
        // Seitentitel
        pageTitle: 'KI-Videoerzeugung',
        pageSubtitle: 'Verwandeln Sie Ihre Kreativität in beeindruckende Videos mit den fortschrittlichsten KI-Modellen',
        no_video_try_these: 'Kein Video? Versuche diese:',
        tools_banner: 'Beispiel',
        recommend_text: 'Empfohlene Materialien',
        do_similar_text: 'Ähnliches erstellen',
        elegant_lady: 'Elegante Dame',
        sweet_girl: 'Süßes Mädchen',
        gentleman: 'Gentleman',
        stage_star: 'Bühnenstar',
        schemaToolTextToVideo: 'Text zu Video KI',
        schemaToolImageToVideo: 'Bild zu Video KI',
        schemaToolVideoToVideo: 'Video zu Video KI',
        schemaSoftwareName: 'WeryAI KI-Videogenerator',
        schemaSoftwareDesc: 'All-in-one KI-Video-Erstellungsplattform mit Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika und mehr. Text zu Video, Bild zu Video, Video zu Video.',
        sectionTools: 'KI-Video-Erstellungstools',
        sectionToolsDesc: 'Erstellen Sie KI-Videos aus Textaufforderungen, Fotos oder vorhandenem Material. Wählen Sie unten Ihre Erstellungsmethode.',
        sectionShowcase: 'KI-Video-Showcase',
        sectionShowcaseDesc: 'Sehen Sie von der Community erstellte KI-Videos mit Veo, Sora 2, Kling und anderen Modellen.',
        sectionModels: 'KI-Videomodelle',
        sectionModelsDesc: 'Zugang zu führenden KI-Videomodellen wie Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika und mehr. Alles auf einer Plattform.',
        sectionInspiration: 'Video-Inspiration',
        sectionInspirationDesc: 'Durchsuchen Sie angesagte KI-Video-Kreationen und erstellen Sie Ihre Lieblingsstile mit einem Klick nach.',
        modelsTitle: 'Modelle',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika u.v.m.',
        toolsDesc: 'Hochskalieren, Lippensync, Gesichtertausch u.v.m.',
        inspirationDesc: 'Ein-Klick-Remix aus Community-Kreationen.',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'Генерация Видео ИИ',
        pageSubtitle: 'Преобразуйте свои идеи в потрясающие видео с помощью самых передовых моделей ИИ',
        no_video_try_these: 'Нет видео? Попробуйте эти:',
        tools_banner: 'Образец',
        recommend_text: 'Рекомендуемые материалы',
        do_similar_text: 'Сделать похожее',
        elegant_lady: 'Элегантная Леди',
        sweet_girl: 'Милая Девушка',
        gentleman: 'Джентльмен',
        stage_star: 'Звезда Сцены',
        schemaToolTextToVideo: 'Текст в видео ИИ',
        schemaToolImageToVideo: 'Изображение в видео ИИ',
        schemaToolVideoToVideo: 'Видео в видео ИИ',
        schemaSoftwareName: 'WeryAI Генератор видеоИИ',
        schemaSoftwareDesc: 'Универсальная платформа создания видео с ИИ: Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika и другие. Текст в видео, Изображение в видео, Видео в видео.',
        sectionTools: 'Инструменты создания видеоИИ',
        sectionToolsDesc: 'Создавайте видео с ИИ из текстовых подсказок, фото или готовых материалов. Выберите способ создания ниже.',
        sectionShowcase: 'Витрина видеоИИ',
        sectionShowcaseDesc: 'Смотрите видео, созданные сообществом с помощью Veo, Sora 2, Kling и других моделей.',
        sectionModels: 'Модели видеоИИ',
        sectionModelsDesc: 'Доступ к лучшим моделям видеоИИ: Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika и другие. Всё на одной платформе.',
        sectionInspiration: 'Видеовдохновение',
        sectionInspirationDesc: 'Просматривайте трендовые видео с ИИ и воссоздавайте любимые стили одним кликом.',
        modelsTitle: 'Модели',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika и др.',
        toolsDesc: 'Улучшение, синхронизация губ, замена лиц и др.',
        inspirationDesc: 'Ремикс одним кликом из работ сообщества.',
    },
    pt: {
        // Título da página
        pageTitle: 'Geração de Vídeos com IA',
        pageSubtitle: 'Transforme sua criatividade em vídeos impressionantes com os modelos de IA mais avançados',
        no_video_try_these: 'Não há vídeo? Tente estes:',
        tools_banner: 'Amostra',
        recommend_text: 'Materiais recomendados',
        do_similar_text: 'Fazer similar',
        elegant_lady: 'Dama Elegante',
        sweet_girl: 'Garota Doce',
        gentleman: 'Cavalheiro',
        stage_star: 'Estrela do Palco',
        schemaToolTextToVideo: 'Texto para Vídeo IA',
        schemaToolImageToVideo: 'Imagem para Vídeo IA',
        schemaToolVideoToVideo: 'Vídeo para Vídeo IA',
        schemaSoftwareName: 'WeryAI Gerador de Vídeos IA',
        schemaSoftwareDesc: 'Plataforma integral de criação de vídeos com IA agregando Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika e mais. Texto para Vídeo, Imagem para Vídeo, Vídeo para Vídeo.',
        sectionTools: 'Ferramentas de criação de vídeo IA',
        sectionToolsDesc: 'Crie vídeos IA a partir de prompts de texto, fotos ou material existente. Escolha seu método de criação abaixo.',
        sectionShowcase: 'Galeria de vídeos IA',
        sectionShowcaseDesc: 'Assista vídeos IA criados pela comunidade com Veo, Sora 2, Kling e outros modelos.',
        sectionModels: 'Modelos de vídeo IA',
        sectionModelsDesc: 'Acesse os principais modelos de vídeo IA incluindo Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika e mais. Tudo em uma plataforma.',
        sectionInspiration: 'Inspiração em vídeo',
        sectionInspirationDesc: 'Navegue por criações de vídeo IA em alta e recrie seus estilos favoritos com um clique.',
        modelsTitle: 'Modelos',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika e mais.',
        toolsDesc: 'Melhorar, sincronização labial, troca de rostos e mais.',
        inspirationDesc: 'Remix com um clique a partir de criações da comunidade.',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Generazione di Video IA',
        pageSubtitle: 'Trasforma la tua creatività in video straordinari con i modelli IA più avanzati',
        no_video_try_these: 'Non c\'è video? Prova questi:',
        tools_banner: 'Esempio',
        recommend_text: 'Materiali consigliati',
        do_similar_text: 'Crea simile',
        elegant_lady: 'Signora Elegante',
        sweet_girl: 'Ragazza Dolce',
        gentleman: 'Gentiluomo',
        stage_star: 'Star del Palco',
        schemaToolTextToVideo: 'Testo a Video IA',
        schemaToolImageToVideo: 'Immagine a Video IA',
        schemaToolVideoToVideo: 'Video a Video IA',
        schemaSoftwareName: 'WeryAI Generatore di Video IA',
        schemaSoftwareDesc: 'Piattaforma all-in-one per la creazione di video IA che aggrega Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika e altri. Testo a Video, Immagine a Video, Video a Video.',
        sectionTools: 'Strumenti di creazione video IA',
        sectionToolsDesc: 'Crea video IA da prompt di testo, foto o materiale esistente. Scegli il metodo di creazione qui sotto.',
        sectionShowcase: 'Galleria video IA',
        sectionShowcaseDesc: 'Guarda i video IA creati dalla community con Veo, Sora 2, Kling e altri modelli.',
        sectionModels: 'Modelli video IA',
        sectionModelsDesc: 'Accedi ai principali modelli video IA tra cui Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika e altro. Tutto in una piattaforma.',
        sectionInspiration: 'Ispirazione video',
        sectionInspirationDesc: 'Sfoglia le creazioni video IA di tendenza e ricrea i tuoi stili preferiti con un clic.',
        modelsTitle: 'Modelli',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika e altri.',
        toolsDesc: 'Migliora, sincronizzazione labiale, scambio volti e altro.',
        inspirationDesc: 'Remix con un clic dalle creazioni della community.',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'إنشاء فيديو بالذكاء الاصطناعي',
        pageSubtitle: 'حوّل إبداعك إلى فيديوهات مذهلة باستخدام أكثر نماذج الذكاء الاصطناعي تقدمًا',
        no_video_try_these: 'ليس هناك فيديو؟ جرب هذه:',
        tools_banner: 'عينة',
        recommend_text: 'مواد موصى بها',
        do_similar_text: 'إنشاء مشابه',
        elegant_lady: 'سيدة أنيقة',
        sweet_girl: 'فتاة حلوة',
        gentleman: 'رجل نبيل',
        stage_star: 'نجم المسرح',
        schemaToolTextToVideo: 'نص إلى فيديو AI',
        schemaToolImageToVideo: 'صورة إلى فيديو AI',
        schemaToolVideoToVideo: 'فيديو إلى فيديو AI',
        schemaSoftwareName: 'WeryAI مولد فيديو AI',
        schemaSoftwareDesc: 'منصة شاملة لإنشاء الفيديو بالذكاء الاصطناعي تجمع Veo 3.1 وSora 2 وSeedance وKling وRunway وPika والمزيد. نص إلى فيديو، صورة إلى فيديو، فيديو إلى فيديو.',
        sectionTools: 'أدوات إنشاء الفيديو بالذكاء الاصطناعي',
        sectionToolsDesc: 'أنشئ مقاطع فيديو بالذكاء الاصطناعي من النصوص أو الصور أو المواد الموجودة. اختر طريقة الإنشاء أدناه.',
        sectionShowcase: 'عرض مقاطع الفيديو بالذكاء الاصطناعي',
        sectionShowcaseDesc: 'شاهد مقاطع الفيديو التي أنشأها المجتمع باستخدام Veo وSora 2 وKling والنماذج الأخرى.',
        sectionModels: 'نماذج الفيديو بالذكاء الاصطناعي',
        sectionModelsDesc: 'الوصول إلى نماذج الفيديو الرائدة بما في ذلك Veo 3.1 وSora 2 وSeedance 2.0 وKling وRunway وPika والمزيد. جميعها في منصة واحدة.',
        sectionInspiration: 'إلهام الفيديو',
        sectionInspirationDesc: 'تصفح إنشاءات الفيديو الرائجة وأعد إنشاء أنماطك المفضلة بنقرة واحدة.',
        modelsTitle: 'النماذج',
        modelsDesc: 'Veo 3.1، Sora 2، Seedance، Kling، Runway، Pika والمزيد.',
        toolsDesc: 'تحسين، مزامنة الشفاه، تبديل الوجوه والمزيد.',
        inspirationDesc: 'نسخ بنقرة واحدة من إبداعات المجتمع.',
    },
    th: {
        // Page title
        pageTitle: 'การสร้างวิดีโอด้วย AI',
        pageSubtitle: 'เปลี่ยนความคิดสร้างสรรค์ของคุณให้เป็นวิดีโอสุดตระการตาด้วยโมเดล AI ที่ล้ำสมัยที่สุด',
        no_video_try_these: 'ไม่มีวิดีโอ? ลองที่นี่:',
        tools_banner: 'ตัวอย่าง',
        recommend_text: 'วัสดุแนะนำ',
        do_similar_text: 'ทำแบบเดียวกัน',
        elegant_lady: 'สุภาพสตรีสง่างาม',
        sweet_girl: 'สาวน่ารัก',
        gentleman: 'สุภาพบุรุษ',
        stage_star: 'ดาวบนเวที',
        schemaToolTextToVideo: 'ข้อความเป็นวิดีโอ AI',
        schemaToolImageToVideo: 'รูปเป็นวิดีโอ AI',
        schemaToolVideoToVideo: 'วิดีโอเป็นวิดีโอ AI',
        schemaSoftwareName: 'WeryAI เครื่องสร้างวิดีโอ AI',
        schemaSoftwareDesc: 'แพลตฟอร์มสร้างวิดีโอ AI แบบครบวงจร รวม Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika และอื่นๆ ข้อความเป็นวิดีโอ รูปเป็นวิดีโอ วิดีโอเป็นวิดีโอ',
        sectionTools: 'เครื่องมือสร้างวิดีโอ AI',
        sectionToolsDesc: 'สร้างวิดีโอ AI จากข้อความ รูปภาพ หรือไฟล์ที่มีอยู่ เลือกวิธีการสร้างด้านล่าง',
        sectionShowcase: 'ตัวอย่างวิดีโอ AI',
        sectionShowcaseDesc: 'ดูวิดีโอ AI ที่สร้างโดยชุมชนด้วย Veo, Sora 2, Kling และโมเดลอื่นๆ',
        sectionModels: 'โมเดลวิดีโอ AI',
        sectionModelsDesc: 'เข้าถึงโมเดลวิดีโอ AI ชั้นนำรวมถึง Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika และอื่นๆ ทั้งหมดในแพลตฟอร์มเดียว',
        sectionInspiration: 'แรงบันดาลใจวิดีโอ',
        sectionInspirationDesc: 'เรียกดูวิดีโอ AI ยอดนิยมและสร้างสรรค์สไตล์ที่คุณชื่นชอบด้วยคลิกเดียว',
        modelsTitle: 'โมเดล',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika และอื่นๆ',
        toolsDesc: 'อัปสเกล ซิงค์ปาก สลับหน้า และอื่นๆ',
        inspirationDesc: 'รีมิกซ์ได้ในคลิกเดียวจากผลงานของชุมชน',
    },
    da: {
        // Page title
        pageTitle: 'AI‑videogenerering',
        pageSubtitle: 'Forvandl din kreativitet til imponerende videoer med de mest avancerede AI‑modeller',
        no_video_try_these: 'Ingen video? Prøv disse:',
        tools_banner: 'Prøve',
        recommend_text: 'Anbefalede materialer',
        do_similar_text: 'Lav lignende',
        elegant_lady: 'Elegant Dame',
        sweet_girl: 'Sød Pige',
        gentleman: 'Gentleman',
        stage_star: 'Scenestjerne',
        schemaToolTextToVideo: 'Tekst til Video AI',
        schemaToolImageToVideo: 'Billede til Video AI',
        schemaToolVideoToVideo: 'Video til Video AI',
        schemaSoftwareName: 'WeryAI AI-videogenerator',
        schemaSoftwareDesc: 'Alt-i-et AI-videooprettelsesplatform der samler Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika og mere. Tekst til Video, Billede til Video, Video til Video.',
        sectionTools: 'AI-videooprettelsesværktøjer',
        sectionToolsDesc: 'Opret AI-videoer fra tekstprompts, fotos eller eksisterende materiale. Vælg din oprettelsesmetode nedenfor.',
        sectionShowcase: 'AI-video showcase',
        sectionShowcaseDesc: 'Se AI-genererede videoer oprettet af fællesskabet med Veo, Sora 2, Kling og andre modeller.',
        sectionModels: 'AI-videomodeller',
        sectionModelsDesc: 'Få adgang til top AI-videomodeller inklusive Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika og mere. Alt på én platform.',
        sectionInspiration: 'Videoinspiration',
        sectionInspirationDesc: 'Gennemse populære AI-videokreationer og genopret dine favoritstile med ét klik.',
        modelsTitle: 'Modeller',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika og mere.',
        toolsDesc: 'Opskalér, læbe‑synk, ansigtsbytte og mere.',
        inspirationDesc: 'Et-klik remix fra fællesskabets kreationer.',
    },
    no: {
        // Page title
        pageTitle: 'AI‑videogenerering',
        pageSubtitle: 'Gjør kreativiteten din om til imponerende videoer med de mest avanserte AI‑modellene',
        no_video_try_these: 'Ingen video? Prøv disse:',
        tools_banner: 'Eksempel',
        recommend_text: 'Anbefalte materialer',
        do_similar_text: 'Lag lignende',
        elegant_lady: 'Elegant Dame',
        sweet_girl: 'Søt Jente',
        gentleman: 'Gentleman',
        stage_star: 'Scenestjerne',
        schemaToolTextToVideo: 'Tekst til Video AI',
        schemaToolImageToVideo: 'Bilde til Video AI',
        schemaToolVideoToVideo: 'Video til Video AI',
        schemaSoftwareName: 'WeryAI AI-videogenerator',
        schemaSoftwareDesc: 'Alt-i-ett AI-videoopprettelsesplattform som samler Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika og mer. Tekst til Video, Bilde til Video, Video til Video.',
        sectionTools: 'AI-videoopprettelsesverktøy',
        sectionToolsDesc: 'Opprett AI-videoer fra tekstprompter, bilder eller eksisterende materiale. Velg din opprettelsesmetode nedenfor.',
        sectionShowcase: 'AI-video showcase',
        sectionShowcaseDesc: 'Se AI-genererte videoer laget av fellesskapet med Veo, Sora 2, Kling og andre modeller.',
        sectionModels: 'AI-videomodeller',
        sectionModelsDesc: 'Få tilgang til topp AI-videomodeller inkludert Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika og mer. Alt på én plattform.',
        sectionInspiration: 'Videoinspirasjon',
        sectionInspirationDesc: 'Bla gjennom populære AI-videoopprettelser og gjenskap favorittstilene dine med ett klikk.',
        modelsTitle: 'Modeller',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika og mer.',
        toolsDesc: 'Oppskalér, leppesync, ansiktsbytte og mer.',
        inspirationDesc: 'Ett-klikk remix fra fellesskapets kreasjoner.',
    },
    nl: {
        // Page title
        pageTitle: 'AI‑videogeneratie',
        pageSubtitle: "Zet je creativiteit om in indrukwekkende video's met de meest geavanceerde AI-modellen",
        no_video_try_these: 'Geen video? Probeer deze:',
        tools_banner: 'Voorbeeld',
        recommend_text: 'Aanbevolen materialen',
        do_similar_text: 'Maak vergelijkbaar',
        elegant_lady: 'Elegante Dame',
        sweet_girl: 'Lief Meisje',
        gentleman: 'Heer',
        stage_star: 'Podiumster',
        schemaToolTextToVideo: 'Tekst naar Video AI',
        schemaToolImageToVideo: 'Afbeelding naar Video AI',
        schemaToolVideoToVideo: 'Video naar Video AI',
        schemaSoftwareName: 'WeryAI AI-videogenerator',
        schemaSoftwareDesc: 'Alles-in-één AI-videocreatieplatform met Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika en meer. Tekst naar Video, Afbeelding naar Video, Video naar Video.',
        sectionTools: 'Tools voor het maken van AI-video\'s',
        sectionToolsDesc: 'Maak AI-video\'s uit tekstprompts, foto\'s of bestaand materiaal. Kies hieronder je maakmethode.',
        sectionShowcase: 'AI-video showcase',
        sectionShowcaseDesc: 'Bekijk AI-gegenereerde video\'s gemaakt door de community met Veo, Sora 2, Kling en andere modellen.',
        sectionModels: 'AI-videomodellen',
        sectionModelsDesc: 'Toegang tot top AI-videomodellen inclusief Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika en meer. Alles op één platform.',
        sectionInspiration: 'Videoinspiratie',
        sectionInspirationDesc: 'Bekijk trending AI-videocreaties en maak je favoriete stijlen na met één klik.',
        modelsTitle: 'Modellen',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika en meer.',
        toolsDesc: 'Opschalen, lipsync, gezichten wisselen en meer.',
        inspirationDesc: 'Eén-klik remix van community-creaties.',
    },
    id: {
        // Page title
        pageTitle: 'Generasi Video AI',
        pageSubtitle: 'Ubah kreativitas Anda menjadi video menakjubkan dengan model AI paling canggih',
        no_video_try_these: 'Tidak ada video? Coba ini:',
        tools_banner: 'Sampel',
        recommend_text: 'Materi Rekomendasi',
        do_similar_text: 'Buat Serupa',
        elegant_lady: 'Wanita Elegan',
        sweet_girl: 'Gadis Manis',
        gentleman: 'Pria Terhormat',
        stage_star: 'Bintang Panggung',
        schemaToolTextToVideo: 'Teks ke Video AI',
        schemaToolImageToVideo: 'Gambar ke Video AI',
        schemaToolVideoToVideo: 'Video ke Video AI',
        schemaSoftwareName: 'WeryAI Generator Video AI',
        schemaSoftwareDesc: 'Platform pembuatan video AI all-in-one yang mengagregasikan Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika dan lainnya. Teks ke Video, Gambar ke Video, Video ke Video.',
        sectionTools: 'Alat Pembuatan Video AI',
        sectionToolsDesc: 'Buat video AI dari prompt teks, foto, atau materi yang ada. Pilih metode pembuatan Anda di bawah.',
        sectionShowcase: 'Galeri Video AI',
        sectionShowcaseDesc: 'Tonton video AI yang dibuat komunitas menggunakan Veo, Sora 2, Kling dan model lainnya.',
        sectionModels: 'Model Video AI',
        sectionModelsDesc: 'Akses model video AI teratas termasuk Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika dan lainnya. Semua dalam satu platform.',
        sectionInspiration: 'Inspirasi Video',
        sectionInspirationDesc: 'Jelajahi kreasi video AI tren dan buat ulang gaya favorit Anda dengan satu klik.',
        modelsTitle: 'Model',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika dan lainnya.',
        toolsDesc: 'Upscale, sinkronisasi bibir, tukar wajah dan lainnya.',
        inspirationDesc: 'Remix satu klik dari kreasi komunitas.',
    },
    tr: {
        // Page title
        pageTitle: 'AI Video Üretimi',
        pageSubtitle: 'Yaratıcılığınızı en gelişmiş AI modelleriyle etkileyici videolara dönüştürün',
        no_video_try_these: 'Video yok? Bu deneyin:',
        tools_banner: 'Örnek',
        recommend_text: 'Önerilen Materyaller',
        do_similar_text: 'Benzerini Yap',
        elegant_lady: 'Zarif Bayan',
        sweet_girl: 'Tatlı Kız',
        gentleman: 'Beyefendi',
        stage_star: 'Sahne Yıldızı',
        schemaToolTextToVideo: 'Metinden Videoya AI',
        schemaToolImageToVideo: 'Görüntüden Videoya AI',
        schemaToolVideoToVideo: 'Videodan Videoya AI',
        schemaSoftwareName: 'WeryAI AI Video Üretici',
        schemaSoftwareDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika ve daha fazlasını bir araya getiren hepsi bir arada AI video oluşturma platformu. Metinden Videoya, Görüntüden Videoya, Videodan Videoya.',
        sectionTools: 'AI Video Oluşturma Araçları',
        sectionToolsDesc: 'Metin istemleri, fotoğraflar veya mevcut görüntülerden AI videoları oluşturun. Aşağıdan oluşturma yönteminizi seçin.',
        sectionShowcase: 'AI Video Vitrin',
        sectionShowcaseDesc: 'Topluluk tarafından Veo, Sora 2, Kling ve diğer modellerle oluşturulan AI videolarını izleyin.',
        sectionModels: 'AI Video Modelleri',
        sectionModelsDesc: 'Veo 3.1, Sora 2, Seedance 2.0, Kling, Runway, Pika ve daha fazlası dahil en iyi AI video modellerine erişin. Hepsi tek platformda.',
        sectionInspiration: 'Video İlhamı',
        sectionInspirationDesc: 'Trend AI video yaratımlarını inceleyin ve favori stillerinizi tek tıkla yeniden oluşturun.',
        modelsTitle: 'Modeller',
        modelsDesc: 'Veo 3.1, Sora 2, Seedance, Kling, Runway, Pika ve daha fazlası.',
        toolsDesc: 'Büyütme, dudak senkronu, yüz değiştirme ve daha fazlası.',
        inspirationDesc: 'Topluluk eserlerinden tek tıkla remix.',
    },
}
